@if (successfullSubmitted) {
  <div class="">
    <div class="row">
      <div class="col-xs-12">
        <div class="p-4 msg-success">
          Die Anmeldung war erfolgreich!
        </div>
      </div>
    </div>
  </div>
} @else {
  <form [class.invalid]="invalid" novalidate [formGroup]="form" (ngSubmit)="submit(form.value)">
    <div class="row">
      <div class="col-xs-12 col-md-6 mb-3">
        <span class="input-wrap" [class.invalid]="form.controls['firstname'].invalid && form.controls['firstname'].touched"
          [class.valid]="form.controls['firstname'].valid && form.controls['firstname'].touched"
          >
          <input type="text" inputTitleCase class="form-control" formControlName="firstname" placeholder="Vorname" aria-label="Vorname" autocomplete="given-name" [attr.aria-invalid]="form.controls['firstname'].invalid && form.controls['firstname'].touched">
        </span>
        <show-form-error text="Vorname" path="firstname"></show-form-error>
      </div>
      <div class="col-xs-12 col-md-6 mb-3">
        <span class="input-wrap" [class.invalid]="form.controls['lastname'].invalid && form.controls['lastname'].touched"
          [class.valid]="form.controls['lastname'].valid && form.controls['lastname'].touched"
          >
          <input type="text" inputTitleCase class="form-control" formControlName="lastname" placeholder="Nachname" aria-label="Nachname" autocomplete="family-name" [attr.aria-invalid]="form.controls['lastname'].invalid && form.controls['lastname'].touched">
        </span>
        <show-form-error text="Nachname" path="lastname"></show-form-error>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 mb-3">
        <span class="input-wrap" [class.invalid]="form.controls['email'].invalid && form.controls['email'].touched"
          [class.valid]="form.controls['email'].valid && form.controls['email'].touched"
          >
          <input placeholder="E-Mail-Adresse" type="email" class="form-control" formControlName="email" aria-label="E-Mail-Adresse" autocomplete="email" [attr.aria-invalid]="form.controls['email'].invalid && form.controls['email'].touched">
        </span>
        <show-form-error text="E-Mail-Adresse" path="email"></show-form-error>
        @if (emailDomainValid === false) {
          <p class="hint" role="alert" aria-live="polite">Die E-Mail-Adresse scheint fehlerhaft zu sein. Hast du dich vielleicht vertippt?</p>
        }
      </div>
    </div>
    <strong class="d-block mt-4 mb-3">Ich möchte mich außerdem zu folgenden kostenlosen Printmedien anmelden:</strong>
    <div formArrayName="subscriptions" class="mb-4">
      @for (subForm of subscriptions.controls; track subForm; let i = $index) {
        @if (subscribeItems[i].type == 'postal') {
          <div class="form-group form-check" [formGroupName]="i">
            <input type="checkbox" [checked]="subscribeItems[i].checked" formControlName="checked" id="{{ subscribeItems[i].code }}_checked" class="form-check-input"  />
            <label for="{{ subscribeItems[i].code }}_checked" class="form-check-label">{{ subscribeItems[i].title }}</label>
          </div>
        }
      }
    </div>
    @if (hasPostal) {
      <div class="row">
        <div class="col-xs-12 mb-3">
          <p [class.txt-red]="invalid">Deine Auswahl enthält Publikationen, die per Post verschickt werden, daher benötigen wir Deine Adresse.</p>
          <gea-shop-address-form #addressForm
            (addressChange)="onAddressChange($event)"
            [hideFields]="['company', 'telephone', 'firstname', 'lastname']"
            />
        </div>
      </div>
    }
    <button type="submit" class="btn btn-green" [disabled]="! form.valid">
      @if (captchaIsLoading) {
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      }
      anmelden
    </button>
    <gea-shop-friendly-captcha
      (getSolution)="pushCaptchaSolution($event)"
      (isLoading)="pushCaptchaLoadingState($event)"
      />
  </form>
}

